import React from 'react';
import {Route, Routes} from 'react-router-dom';
import SignUp from './pages/SignUp';
import UsernameSetup from './pages/UsernameSetup';
import Profile from './pages/Profile';
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Home from "./pages/Home";
import {HelmetProvider} from "react-helmet-async";
import Restaurant from "./pages/Restaurant";
import Cookies from "./pages/Cookies";
import ScrollToTop from './pages/ScrollToTop';
import Sitemap from "./pages/Sitemap";
import PromotionRedeem from "./pages/PromotionRedeem";
import RestaurantPromotionsPresentation from "./pages/RestaurantPromotionsPresentation";
import RestaurantPromotionsPresentationRedirect from "./pages/RestaurantPromotionsPresentationRedirect";
import NotFound from "./pages/NotFound";
import GeoCityGate from './components/GeoCityGate';
import CityGeoHub from './pages/geo/CityGeoHub';
import GeoBestRestaurants from './pages/geo/GeoBestRestaurants';
const App: React.FC = () => {
    return (
        <HelmetProvider>
            <ScrollToTop/>
            <Routes>
                <Route path="/creator/sign-up" element={<SignUp/>}/>
                <Route path="/creator/setup-username" element={<UsernameSetup/>}/>

                <Route path="/sitemap" element={<Sitemap/>}/>
                <Route path="/" element={<Home/>}/>

                <Route path="/restaurant-promotions-presentations" element={<RestaurantPromotionsPresentationRedirect/>}/>
                <Route path="/restaurant-promotions-presentations/ro" element={<RestaurantPromotionsPresentation/>}/>

                <Route path="/privacy" element={<Privacy/>}/>
                <Route path="/cookies" element={<Cookies/>}/>
                <Route path="/terms" element={<Terms/>}/>

                <Route path="/:country/:city" element={<GeoCityGate/>}>
                    <Route index element={<CityGeoHub/>}/>
                    <Route path="best-restaurants" element={<GeoBestRestaurants/>}/>
                </Route>
                <Route path="/@:username" element={<Profile/>}/>
                <Route path="/restaurant/:link" element={<Restaurant/>}/>
                <Route path="/r/:token" element={<PromotionRedeem/>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </HelmetProvider>
    );
};

export default App;
